export default "__VITE_ASSET__HKdgT0Sy__"